/* eslint-disable no-var */
/* eslint-disable eol-last */
import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';


declare var google: any;
@Component({
  selector: 'app-google-map-testing',
  templateUrl: './google-map-testing.page.html',
  styleUrls: ['./google-map-testing.page.scss'],
})
export class GoogleMapTestingPage implements AfterViewInit{
  @ViewChild('map', { static: false }) mapElement!: ElementRef;

  map: any;

  constructor() {}

  ngAfterViewInit() {
    this.loadMap();
  }

  loadMap() {
    const latLng = new google.maps.LatLng(31.5204, 74.3587); // Dubai
    const mapOptions = {
      center: latLng,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);

    // Optional: Add a marker
    new google.maps.Marker({
      position: latLng,
      map: this.map,
      title: 'Lahore'
    });
  }
}